import { AUTH_INFO, ATTEMPT_LOGIN, ATTEMPT_REGISTER } from './types'

export const setAuthInfo = (authInfo) => ({
    type: AUTH_INFO,
    payload: authInfo
})

export const attemptLogin = (formData) => ({
    type: ATTEMPT_LOGIN,
    payload: formData
})

export const attemptRegister = (formData) => ({
    type: ATTEMPT_REGISTER,
    payload: formData
})